module.exports = __webpack_public_path__ + "img/30.bed377f5.jpg";